<template functional>
    <div :class="[
        'group card bg-base-100 shadow-lg hover:shadow-xl transition-all duration-300 border border-base-300 hover:border-primary/30 cursor-pointer transform hover:scale-105 active:scale-95',
        props.small ? 'tile-small' : 'tile-normal'
    ]" @click="props.to && parent.$router.push(props.to)">
        <figure :class="[
            'tile-img overflow-hidden',
            props.square ? 'tile-img-square' : 'tile-img-rect'
        ]">
            <div class="block w-full h-full">
                <img 
                    v-if="props.image" 
                    v-lazy="props.image" 
                    :alt="props.title || parent.$tt('专辑封面')"
                    class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                >
                <img 
                    v-else 
                    v-lazy="'/static/dist/img/album_null.jpg'" 
                    :alt="props.title || parent.$tt('默认封面')"
                    class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                >
            </div>
            
            <!-- 播放按钮覆盖层 -->
            <div class="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center pointer-events-none">
                <div @click.stop class="play-button-container pointer-events-auto">
                    <slot name="play">
                    </slot>
                </div>
            </div>
        </figure>
        
        <div class="card-body p-3 md:p-4">
            <div class="space-y-1">
                <h3 class="card-title text-sm md:text-base font-semibold line-clamp-2 leading-tight">
                    <slot name="title">
                        <span class="link link-hover hover:text-primary transition-colors duration-200">
                            {{ props.title }}
                        </span>
                    </slot>
                </h3>
                
                <p class="text-xs md:text-sm text-base-content/70 line-clamp-2 leading-relaxed">
                    <slot name="text">
                        {{ props.text }}
                    </slot>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        image: {
            type: String, 
            default: null
        },
        to: {
            type: [String, Object], 
            default: null
        },
        title: {
            type: String, 
            default: null
        },
        text: {
            type: String, 
            default: null
        },
        square: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        allowHScroll: {
            type: Boolean,
            default: false
        }
    },
    components: {}
}
</script>

<style scoped>
.tile-img {
    position: relative;
    width: 100%;
    border-radius: 1rem 1rem 0 0;
}

.tile-img-square {
    height: 0;
    padding-bottom: 100%;
}

.tile-img-rect {
    height: 0;
    padding-bottom: 70%;
}

.tile-img img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.tile-small .tile-img-square {
    padding-bottom: 100%;
}

.tile-small .tile-img-rect {
    padding-bottom: 65%;
}

.tile-small .card-body {
    padding: 0.75rem;
}

.tile-small .card-title {
    font-size: 0.875rem;
}

.tile-small .card-body p {
    font-size: 0.75rem;
}

.line-clamp-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

@media (max-width: 768px) {
    .tile-img-square {
        padding-bottom: 100%;
    }
    
    .tile-img-rect {
        padding-bottom: 75%;
    }
    
    .group:active {
        transform: scale(0.98);
    }
    
    .group:hover {
        transform: none;
    }
}

@media (hover: none) and (pointer: coarse) {
    .group:hover {
        transform: none;
        box-shadow: var(--tw-shadow);
    }
    
    .group:active {
        transform: scale(0.98);
        box-shadow: var(--tw-shadow-xl);
    }
    
    .group:hover .tile-img img {
        transform: none !important;
    }
    
    .group:active .tile-img img {
        transform: none !important;
    }
    
    .group:hover .tile-img .absolute {
        opacity: 0;
    }
}

.card {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.card-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}

.card:focus-within {
    outline: 2px solid hsl(var(--p));
    outline-offset: 2px;
}

.tile-img img {
    background-color: hsl(var(--b2));
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
    .tile-img img {
        image-rendering: -webkit-optimize-contrast;
        image-rendering: crisp-edges;
    }
}

/* 播放按钮覆盖层相关样式 */
.pointer-events-none {
    pointer-events: none;
}

.pointer-events-auto {
    pointer-events: auto;
}

/* 播放按钮容器 */
.play-button-container {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
